<template>
  <div class="kiosk-keyboard">
    <div class="keyboard-surface">
      <div class="keyboard-header">
        <button class="language-toggle" @click="switchLayout()">
          <span>{{ isThaiLayout ? "TH" : "EN" }}</span>
          <small>Change language</small>
        </button>
      </div>
      <div class="simple-keyboard"></div>
    </div>
  </div>
</template>

<script>
import thai from "simple-keyboard-layouts/build/layouts/thai";
import english from "simple-keyboard-layouts/build/layouts/english";
import Keyboard from "simple-keyboard";
import "simple-keyboard/build/css/index.css";

export default {
  name: "SimpleKeyboard",
  data: () => ({
    keyboard: null,
    layout: english,
    isThaiLayout: false,
  }),
  mounted() {
    this.createKeyboard();
  },
  methods: {
    switchLayout() {
      this.isThaiLayout = !this.isThaiLayout;
      this.keyboard.setOptions({
        layout: this.isThaiLayout ? thai : english,
      });
    },
    createKeyboard() {
      this.keyboard = new Keyboard({
        onChange: this.onChange,
        onKeyPress: this.onKeyPress,
        layout: this.layout,
      });

      this.setKeyboardInput(this.input);
    },
    onChange(input) {
      this.$emit("onChange", input);
    },
    onKeyPress(button) {
      this.$emit("onKeyPress", button);

      if (button === "{shift}" || button === "{lock}") {
        this.handleShift();
      }
    },
    handleShift() {
      const currentLayout = this.keyboard.options.layoutName;
      const shiftToggle = currentLayout === "default" ? "shift" : "default";

      this.keyboard.setOptions({
        layoutName: shiftToggle,
      });
    },
    setKeyboardInput(input) {
      this.keyboard.setInput(input);
    },
    hideKeyboard() {
      this.$emit("closeKeyboard");
    },
  },
  watch: {
    input(input) {
      this.setKeyboardInput(input);
    },
  },
};
</script>

<style scoped>
.kiosk-keyboard {
  width: 100%;
}

.language-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 38px;
  padding: 7px 12px;
  background:
    linear-gradient(180deg, #536176 0%, #344054 62%, #1f2937 100%);
  border: 1px solid rgba(255, 255, 255, 0.38);
  border-radius: 999px;
  box-shadow:
    0 8px 16px rgba(16, 24, 40, 0.18),
    inset 0 2px 0 rgba(255, 255, 255, 0.22);
  color: #fff;
  cursor: pointer;
  font-family: Kanit, Arial, sans-serif;
  font-weight: 900;
}

.language-toggle span {
  min-width: 30px;
  min-height: 26px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #344054;
  background: #ffffff;
  border-radius: 999px;
  font-size: 14px;
}

.language-toggle small {
  color: #ffffff;
  font-size: 13px;
  line-height: 1;
}

.keyboard-surface {
  width: 100%;
}

.keyboard-header {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 6px;
}

.simple-keyboard {
  background: transparent;
  padding: 0;
}

.simple-keyboard ::v-deep .hg-row {
  gap: 5px;
  margin-bottom: 5px;
}

.simple-keyboard ::v-deep .hg-button {
  height: clamp(34px, 3.4vh, 46px);
  border: 1px solid rgba(52, 64, 84, 0.14);
  border-radius: 10px;
  background:
    linear-gradient(180deg, #ffffff 0%, #f2f4f7 100%);
  box-shadow:
    0 3px 0 rgba(152, 162, 179, 0.6),
    0 8px 14px rgba(16, 24, 40, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.95);
  color: #1f2937;
  font-family: Kanit, Arial, sans-serif;
  font-size: clamp(15px, 1.1vw, 20px);
  font-weight: 800;
}

.simple-keyboard ::v-deep .hg-button:active {
  transform: translateY(3px);
  box-shadow:
    0 1px 0 rgba(152, 162, 179, 0.8),
    0 4px 8px rgba(16, 24, 40, 0.08),
    inset 0 2px 6px rgba(16, 24, 40, 0.12);
}

.simple-keyboard ::v-deep .hg-button[data-skbtn="{bksp}"],
.simple-keyboard ::v-deep .hg-button[data-skbtn="{enter}"],
.simple-keyboard ::v-deep .hg-button[data-skbtn="{shift}"],
.simple-keyboard ::v-deep .hg-button[data-skbtn="{lock}"],
.simple-keyboard ::v-deep .hg-button[data-skbtn="{tab}"] {
  background:
    linear-gradient(180deg, #667085 0%, #344054 100%);
  color: #ffffff;
  box-shadow:
    0 3px 0 #1f2937,
    0 8px 14px rgba(16, 24, 40, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
}
</style>
